import {AbbreviatedLegacyClass} from "@/shared/legacyTypes/fetchAllClassesForCampusTypes";
import EnrollInClassButton from "./EnrollInClassButton";
import EnrollStatus from "@/app/types/EnrollStatus";
import {Class} from "@/lib/legacyApi/fetchClassesForCourseByCampusId";
import {ButtonVariant} from "@/app/_components/ButtonVariants";
import RACButton from "@/app/_components/RACButton";

export const CTAButtonForClass = ({
	classInfo,
}: {
	classInfo: Class | AbbreviatedLegacyClass;
}) => {
	switch (classInfo.enrollStatus) {
		case EnrollStatus.OPEN:
			return (
				<EnrollInClassButton
					gtmId={`class-list-add-to-cart-button-${classInfo.classId}`}
					class={classInfo}
				>
					ADD TO CART
				</EnrollInClassButton>
			);
		case EnrollStatus.WAITLIST:
			return (
				<EnrollInClassButton
					gtmId="class-list-join-waitlist-button"
					class={classInfo}
					variant={ButtonVariant.OUTLINE_DARK}
				>
					JOIN WAITLIST
				</EnrollInClassButton>
			);
		default:
			return (
				<RACButton
					variant={ButtonVariant.GRAY_SECONDARY}
					className={"rounded-md px-4"}
					isDisabled={true}
				>
					Closed
				</RACButton>
			);
	}
};
